import { TableProps } from 'antd';
// 2023/10/10 Leading Win 作業員シフト表廃止対応 start
// import { accordionCloseIcon, accordionOpenIcon } from 'assets';
// 2023/10/10 Leading Win 作業員シフト表廃止対応 end
import { StatusRky } from 'constant';
import { Children, Fragment, PropsWithChildren, ReactNode } from 'react';
import Table from '../Table';
import { SiteAgentStyled, StatusJobStyled, StatusRkyStyled } from './styles';

type Props<T> = TableProps<T> & {
  expandedRowRender: ReactNode;
};
type PropStatusRkyFC = {
  status?: number;
  numberNotAprove?: number | null;
};
type PropStatusJobFC = {
  status?: number | string | null;
};

export default function TableGroup<T = {}>({ expandedRowRender, ...props }: Props<T>) {
  return (
    <SiteAgentStyled>
      <Table
        components={{ body: { wrapper: TableGroup.Wrapper } }}
        // 2023/10/10 Leading Win 作業員シフト表廃止対応 start
        // expandable={{
        //   expandIcon: ({ expanded, onExpand, record }) =>
        //     expanded ? (
        //       <div onClick={(e) => onExpand(record, e)}>
        //         <img src={accordionCloseIcon} alt="" />
        //       </div>
        //     ) : (
        //       <div onClick={(e) => onExpand(record, e)}>
        //         <img src={accordionOpenIcon} alt="" />
        //       </div>
        //     ),
        //   expandedRowRender,
        // }}
        // 2023/10/10 Leading Win 作業員シフト表廃止対応 end
        rowKey={(_, index) => index ?? ''}
        {...props}
      />
    </SiteAgentStyled>
  );
}

TableGroup.StatusJobFC = ({ status }: PropStatusJobFC) => {
  const renderStatus = (status?: number | string | null) => {
    switch (status) {
      case 0:
        return { title: '未着工', color: '#7F7F7F' };
      case 1:
        return { title: '休止中', color: '#E65050' };
      case 2:
        return { title: '作業中', color: '#69B362' };
      default:
        return { title: '', color: 'transparent' };
    }
  };

  return (
    <StatusJobStyled color={renderStatus(status).color}>
      {renderStatus(status).title}
    </StatusJobStyled>
  );
};

TableGroup.StatusRkyFC = ({ status, numberNotAprove }: PropStatusRkyFC) => {
  const genStatus = () => {
    switch (status) {
      case StatusRky.APPROVED:
        return (
          <div className="box-status approved">
            <div>承認済</div>
          </div>
        );
      case StatusRky.NOT_PROVED:
        return (
          <div className="box-status">
            <div>未承認</div>
            <div className="line" />
            <div>{numberNotAprove && String(numberNotAprove)}件</div>
          </div>
        );
      default:
        return null;
    }
  };
  return <StatusRkyStyled>{genStatus()}</StatusRkyStyled>;
};
TableGroup.Wrapper = ({ className, children }: PropsWithChildren<{ className: string }>) => {
  return (
    <>
      {Children.toArray(children).map((groupRow, index) => (
        <Fragment key={index}>
          <tbody className={`${className}`} children={groupRow} />
          <tbody className="separate" />
        </Fragment>
      ))}
    </>
  );
};
